<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/bs-form-lookup"></require>
  <require from="controls/as-widget-stack"></require>
  <require from="controls/bs-form-input"></require>
  <require from="controls/bs-form-select"></require>
  <require from="controls/bs-form-textarea"></require>

  <as-form-section heading="Request description" intro="Please identify who and why is requesting the change and when the change should be effective.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-lookup label.bind="userGroupLabel" placeholder="Find by surname, login or email" item.bind="model.requestedBy & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" disabled.bind="controller.disabled" tooltip="Type to search for bp employee, then pick the one from the list"></bs-form-lookup>
        </div>
        <div class="col-md-6">
          <bs-form-input type="date" label="Effective from" value.bind="model.effectiveFrom | dateInput & validate" min.bind="today" max.bind="maxDate" disabled.bind="controller.disabled"></bs-form-input>
        </div>
      </div>
      <div class="form-row">
        <div class="col">
          <bs-form-textarea label="Note" placeholder="Reason for the change request" value.bind="model.note" disabled.bind="controller.disabled"></bs-form-textarea>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Country Settings" intro="Update country settings which you want to change.">
    <div slot="body">
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-select label="Approval" placeholder="Select approval" value.bind="model.data.approvalRequirement & validate" options.bind="enumService.approvalRequirements" matcher.bind="enumsItemMatcher" name-path="name" disabled.bind="controller.disabled"></bs-form-select>
        </div>
        <div class="col-md-6">
          <bs-form-select label="Approval Level" placeholder="Select approval level" value.bind="model.data.approvalLevel & validate" options.bind="approvalLevels" matcher.bind="keywordsItemMatcher" name-path="name" disabled.bind="controller.disabled"></bs-form-select>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <bs-form-select label="Approval Category" placeholder="Select approval category" value.bind="model.data.approveType & validate" options.bind="enumService.approvalTypes" matcher.bind="enumsItemMatcher" name-path="name" disabled.bind="controller.disabled"></bs-form-select>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Approvers" intro="Request to add or remove approvers for this country.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <as-widget-stack kind="admin-user-selector" widget-buttons.bind="approverButtons" new-item-widget-visible.bind="approversEditing" items.bind="model.data.approversWrapper" empty-item-template.bind="newEmptySystemUserWrapper" add-new-item.call="addNewApprover(item)" disabled.bind="controller.disabled"></as-widget-stack>
        </div>
      </div>
    </div>
  </as-form-section>
  <as-form-section heading="Changes" intro="List of changes you are requesting.">
    <div slot="body">
      <div class="form-row">
        <div class="col">
          <ul>
            <li repeat.for="change of model.changes">${change}</li>
          </ul>
        </div>
      </div>
    </div>
  </as-form-section>
</template>
